import { CurrencyRates } from '../../schema';
import { CakeApiBase } from '../CakeApiBase';

export class CurrencyRatesApi extends CakeApiBase {
  async list() {
    const rates = await this.requestManager.get<CurrencyRates>('currencyRates');
    return rates;
  }
}
